<template>
  <iModal
    primary-action-button-label="Save"
    :primary-action-button-loading="isLoading"
    :primary-action-button-disabled="!name"
    :visible="open"
    :max-width="750"
    :title="modalTitle"
    @close="closeModal"
    @click:primary="submit"
  >
    <template #body>
      <iColumn>
        <iRow gap="large" vertical-align="middle">
          <iImageContainer :src="imageSrc" :height="100" />
          <iUploader @upload-file="uploadAffiliateLinkCollectionCover">
            <iButton variant="secondary" size="small">
              {{ checkForSelectedImage ? "Change" : "Select" }} Cover Image
            </iButton>
          </iUploader>
        </iRow>
        <iRow>
          <iTextInput v-model="name" placeholder="Fall Outfits" label="Name" />
        </iRow>
        <iColumn>
          <iTextArea v-model="description" placeholder="Ideas to post Labor Day - Thanksgiving" label="Description" />
          <iRow gap="extraLarge">
            <iRadioButton v-model="visibility" value="public" label="Public" />
            <iRadioButton v-model="visibility" value="private" label="Private" />
          </iRow>
        </iColumn>
      </iColumn>
    </template>
  </iModal>
</template>
<script>
import { mapActions, mapState, mapWritableState } from "pinia";
import { useAffiliateLinkStore } from "%/stores/affiliate-link-store";
import { DEFAULT_COLLECTION_COVER_IMAGE } from "@/constants/affiliate-constants";
import { useGeneralStore } from "%/stores/general-store";

export default {
  name: "CollectionDetailsModal",
  props: {
    open: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["close", "save"],
  data() {
    return {
      name: "",
      category: "",
      description: "",
      coverImage: "",
      coverImageUpload: null,
      visibility: "public",
      DEFAULT_COLLECTION_COVER_IMAGE,
    };
  },
  computed: {
    ...mapState(useAffiliateLinkStore, [
      "loadingAffiliateLinkCollection",
      "loadingAffiliateLinkCollection",
      "uploadedAffiliateLinkCollectionCoverUrl",
    ]),
    ...mapState(useGeneralStore, ["orgId"]),
    ...mapWritableState(useAffiliateLinkStore, [
      "showCollectionModal",
      "editingCollection",
    ]),
    isEditContext() {
      return !!this.editingCollection.collectionId;
    },
    modalTitle() {
      if (this.isEditContext) {
        return "Edit Collection";
      }
      return "Create Collection";
    },
    checkForSelectedImage() {
      return this.coverImage || this.uploadedAffiliateLinkCollectionCoverUrl;
    },
    imageSrc() {
      if (this.uploadedAffiliateLinkCollectionCoverUrl) {
        return this.uploadedAffiliateLinkCollectionCoverUrl;
      } else if (this.coverImage) {
        return this.coverImage;
      } else {
        return this.DEFAULT_COLLECTION_COVER_IMAGE;
      }
    },
    isLoading() {
      return this.loadingAffiliateLinkCollection || this.loadingAffiliateLinkCollection;
    },
  },
  created() {
    if (this.isEditContext) {
      this.name = this.editingCollection.name;
      this.category = this.editingCollection.category;
      this.description = this.editingCollection.description;
      this.coverImage = this.editingCollection.coverImageUrl;
      this.visibility = this.editingCollection.visibility;
    }
  },
  methods: {
    ...mapActions(useAffiliateLinkStore, [
      "saveCollectionDetails",
      "createMonetizationLinkCollection",
      "editAffiliateLinkCollection",
      "uploadAffiliateLinkCollectionCover",
    ]),
    closeModal() {
      this.showCollectionModal = false;
      this.editingCollection = {};
    },
    submit() {
      if (!this.name) {
        return;
      }
      if (this.isEditContext) {
        this.editAffiliateLinkCollection(
          this.editingCollection.collectionId,
          this.name,
          this.description,
          this.imageSrc,
          this.visibility,
        );
      } else {
        this.createMonetizationLinkCollection(
          this.orgId,
          this.name,
          this.description,
          this.imageSrc,
          undefined,
          this.visibility,
        );
      }
    },
  },
};
</script>
